import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'marketFilter',
    standalone: false
})
export class MarketFilterPipe implements PipeTransform {
    transform(items: any[], marketType: string, fieldName: string): any[] {
        if (!items) {
            return [];
        }
        
        if (!marketType || marketType === 'all') {
            return items;
        }

        return items.filter(item => {
            if (fieldName === 'market.sc') {
                if (item && item.market.sc) {
                    return item.market.sc === marketType;
                }
            } else {
                if (item && item[fieldName]) {
                    return item[fieldName] === marketType;
                }
            }

            return false;
        });
    }
}
